import { render, staticRenderFns } from "./VocabularyWordsRusForm.vue?vue&type=template&id=7d066ed9&scoped=true&lang=pug&"
import script from "./VocabularyWordsRusForm.vue?vue&type=script&lang=js&"
export * from "./VocabularyWordsRusForm.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyWordsRusForm.vue?vue&type=style&index=0&id=7d066ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d066ed9",
  null
  
)

export default component.exports